import styled from 'styled-components';

export const CarouselCardBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-basis: 20%;
  padding-right: 1.875em;

  @media (max-width: 720px) {
    flex-basis: 40%;
    padding-right: 0.875em;
    &:nth-child(1) {
      margin-left: 10px;
    }
  }
`;

export const CardContent = styled.p`
  font-size: clamp(13px, 2vw, 16px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  line-height: 1.5;
  text-align: center;
  padding: 8px 14px 20px;

  @media (max-width: 720px) {
    padding: 8px 0 8px;
  }
`;

export const RelativeDiv = styled.div`
  position: relative;
`;
